<template>
    <div id="modal-dropdown-menu" class="tw-absolute tw-bg-white tw-p-2 tw-rounded tw-flex tw-flex-col tw-text-gray-text tw-z-20" ref="menu" :class="align" v-click-outside="clickOutside">
        <slot></slot>
    </div>
</template>

<script>
    import vClickOutside from 'v-click-outside';

    export default {
        name: 'DropdownMenu',

        data() {
            return {
                align: 'right',
                clickOutside: {
                    handler: this.close,
                    events: ['dblclick', 'click'],
                },
            };
        },

        props: {
            open: {
                type: Boolean,
                default: false,
            },

            forceAlign: {
                type: String,
                default: ''
            }
        },

        mounted() {
            if(this.forceAlign) {
                this.align = this.forceAlign;
            } else {
                const element_info = this.$refs.menu.getBoundingClientRect();
                const screen_width = window.innerWidth;

                // check if element doesnt fall off the screen on the right side
                if (element_info.right > screen_width) {
                    this.align = 'left';
                }
            }
        },

        methods: {
            close() {
                this.$emit('close');
            },
        },

        directives: {
            clickOutside: vClickOutside.directive
        },
    };
</script>

<style lang="scss" scoped>
    #modal-dropdown-menu {
        box-shadow: 0 3px 6px #0000004A;
        width: 150px;
        animation: animate-dropdown-in .1s forwards;

        &.left {
            right: 0;
            left: auto;
        }

        &.big {
            width: 200px;
        }

        &.large {
            width: 213px;
        }

        &.xlarge {
            width: 300px;
        }

        @keyframes animate-dropdown-in {
            0% {
                top: calc(100% - 6px);
                opacity: 0;
            }
            100% {
                top: calc(100% - 3px);
                opacity: 1;
            }
        }
    }
</style>
